import { Tile, TileCaption, TileImage, TileOverlay } from '@mc/design-system'
import Image from 'components/LegacyImage'
import styles from './ProductExplainer.module.scss'

interface FullImageTileProps {
  title: string
  description: string
  imageUrl: string
}

const FullImageTile = ({
  title,
  description,
  imageUrl,
}: FullImageTileProps) => (
  <Tile className={styles.section}>
    <TileOverlay
      className='d-none d-lg-block mc-corners--md'
      type='gradient-left'
    />
    <TileOverlay className='d-lg-none mc-corners--md' type='gradient-top' />
    <TileCaption
      className={`mc-m-6 ${styles.sectionCopy}`}
      padding={0}
      position='left top'
    >
      <h3 className='mc-text-h4'>{title}</h3>
      <p className='mc-mt-2'>{description}</p>
    </TileCaption>
    <TileImage
      className='mc-corners--md'
      alt=''
      image={<Image alt='' src={imageUrl} layout='fill' />}
    />
  </Tile>
)

export default FullImageTile
